"use client";
import { jsxs as f, jsx as s } from "react/jsx-runtime";
import r from "clsx";
import { useState as v, Children as x, useEffect as b } from "react";
import { Box as j } from "../blocks/base/Base.js";
import { Button as _ } from "../buttons/button/Button.js";
import C from "../hooks/useOutsideClick.js";
import '../assets/Dropdown.css';const h = "_box_jv8nm_1", w = "_button_jv8nm_6", y = "_list_jv8nm_10", g = "__open_jv8nm_26", k = "_inner_jv8nm_32", E = "__scrolled_jv8nm_35", n = {
  box: h,
  button: w,
  list: y,
  _open: g,
  inner: k,
  _scrolled: E
}, R = ({ children: e, ...t }) => {
  const [o, c] = v(!1), l = () => {
    c(!o);
  }, m = () => {
    c(!1);
  }, d = () => {
    setTimeout(() => {
      c(!1);
    }, 200);
  }, u = C(o, l), p = x.count(e) > 5;
  return b(() => {
    const i = (a) => a.key === "Escape" ? m() : null;
    return document.body.addEventListener("keydown", i), () => {
      document.body.removeEventListener("keydown", i);
    };
  }, []), /* @__PURE__ */ f("div", { className: n.box, ref: u, children: [
    /* @__PURE__ */ s(
      _,
      {
        iconRight: o ? "close" : "arrow_drop_down",
        className: r(n.button, { [n._active]: o }),
        onClick: l,
        ...t
      }
    ),
    /* @__PURE__ */ s(
      "div",
      {
        className: r(n.list, {
          [n._open]: o
        }),
        onClick: d,
        children: /* @__PURE__ */ s(
          j,
          {
            gap: 4,
            className: r(n.inner, {
              [n._scrolled]: p
            }),
            children: e
          }
        )
      }
    )
  ] });
}, K = ({
  active: e,
  color: t,
  ...o
}) => /* @__PURE__ */ s(
  _,
  {
    iconRight: e ? "done" : "",
    color: t || (e ? "regular" : "none"),
    wide: !0,
    centerText: !0,
    ...o
  }
);
export {
  R as DropdownBox,
  K as DropdownItem
};
